/*
 * @Desc:
 * @Author: Sunshy
 * @Date: 2019-01-16 15:12:47
 * @Last Modified by: Sunshy
 * @Last Modified time: 2019-01-16 15:18:59
 */
import React, { Component } from "react";
import { areaCodeList } from "../../utils/areaCode";
import { SearchBar } from "antd-mobile";
import "./style";

// 按照首字母的分组
const FirstWordGroup = ({ groupKey, data, clickEvent }) => {
  if (!data.length) {
    return null;
  }
  return (
    <ul className="area-code-group">
      <li id={groupKey}>{groupKey === "#" ? "常用" : groupKey}</li>
      {data.map(({ name, code, index }) => (
        <li
          key={index}
          onClick={() => {
            clickEvent(code);
          }}
        >
          <span>{name}</span>
          <span>{code}</span>
        </li>
      ))}
    </ul>
  );
};
// 每个分组的导航（导航ABCDE...)
const FirstWordList = ({ data }) => (
  <ul className="first-word-list">
    {data.map(item => (
      <li key={item}>
        <a href={`#${item}`}>{item}</a>
      </li>
    ))}
  </ul>
);

class AreaCodeSelect extends Component {
  state = {
    value: "", // 查询的值
    matchRes: areaCodeList //匹配的结果
  };
  onChange = value => {
    // 搜索
    const matchRes = {}; // 渲染的数据
    for (let group in areaCodeList) {
      // 遍历数据进行筛选
      const data = areaCodeList[group];
      matchRes[group] = [];
      data.forEach(item => {
        const { name, code, engName, firstWord, shouzimu } = item;
        // 按照数据的name,code,首字母，英文名，中文缩写筛选数据,放在一个数组里
        if (
          ~name.toLowerCase().indexOf(value) ||
          ~code.indexOf(value) ||
          ~engName.toLowerCase().indexOf(value) ||
          ~firstWord.toLowerCase().indexOf(value) ||
          ~shouzimu.toLowerCase().indexOf(value)
        ) {
          matchRes[group].push(item);
        }
      });
      if (matchRes[group].length === 0) {
        // 若某分组没有数据，直接删除改分组
        delete matchRes[group];
      }
    }
    // 搜索时，删除常用分组
    delete matchRes["#"];
    // 重置渲染数据
    this.setState({ value, matchRes });
  };
  render() {
    const { hideDrawer } = this.props;
    const { value, matchRes } = this.state;
    const groupsArr = [];
    const firstWordsArr = [];
    const isMatched = Object.keys(matchRes).length > 0;
    for (let item in matchRes) {
      // 根据查询结果，分组渲染每个组的组件
      groupsArr.push(
        <FirstWordGroup
          clickEvent={hideDrawer}
          groupKey={item}
          key={item}
          data={matchRes[item]}
        />
      );
      if (matchRes[item].length > 0) {
        firstWordsArr.push(item);
      }
    }
    return (
      <div className="area-code-select">
        <SearchBar
          value={value}
          placeholder="搜索"
          onCancel={() => {
            hideDrawer(0);
          }}
          showCancelButton
          onChange={this.onChange}
        />
        {isMatched && (
          <div className="area-code-group-list">
            {groupsArr.map(item => item)}
            <FirstWordList data={firstWordsArr} />
          </div>
        )}
        {!isMatched && <div className="not-found">没找到！</div>}
      </div>
    );
  }
}

export default AreaCodeSelect;



// WEBPACK FOOTER //
// ./src/components/AreaCode/index.jsx